
import { graphql, PageProps, useStaticQuery } from "gatsby"
import { IBrandsSection, ICsrSection, IInformationsSection, IIntroSection, IMissionSection, IPeopleSection, IPostsSection, IStatisticsSection, ICareerSection } from "interfaces/sections"
import { Brand, Csr, Information, Person, Post } from "types"
import OpenGraph from "types/opengraph"
import { StringMappingType } from "typescript"
import Media from "../types/media"


export type MainPageData = {
  title: string,
  intro: IIntroSection,
  mission: IMissionSection,
  csr: ICsrSection,
  brands: IBrandsSection,
  statistics: IStatisticsSection,
  informations: IInformationsSection,
  posts: IPostsSection,
  postsExtra: IPostsSection,
  career: ICareerSection,
  openGraph: OpenGraph,
}

const useMainPageData = (): MainPageData => {
  const { allWpPage } = useStaticQuery(graphql`
  query {
    allWpPage(filter: {slug: {eq: "ofirmie"}}) {
        nodes {
          id
          title,
          intro {
            title,
            active,
            background {
              backgroundvideo{
                mimeType,
                mediaItemUrl,
                mediaType,
                altText,
                title
                sourceUrl
                gatsbyVideo: localFile {
                  relativePath
                  publicURL
                }
              }
              backgroundvideomobile{
                mimeType,
                mediaItemUrl,
                mediaType,
                altText,
                title
                sourceUrl
                gatsbyVideo: localFile {
                  relativePath
                  publicURL
                }
              }
              
            }
            imagebackground: imagebackground {
              imagebackgrounddesktop{
                mimeType,
                mediaItemUrl,
                mediaType,
                altText,
                title
                gatsbyImage: localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 1920
                      placeholder: BLURRED
                      formats: [AUTO, WEBP]
                    )
                  }
                }
              }
              imagebackgroundmobile{
                mimeType,
                mediaItemUrl,
                mediaType,
                altText,
                title
                gatsbyImage: localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 1920
                      placeholder: BLURRED
                      formats: [AUTO, WEBP]
                    )
                  }
                }
              }
              
            }
          },
          mission {
            title: missiontitle,
            active: missionactive,
            description: missiondescription
          },
          csr{
            title: csrtitle,
            active: csractive,
            sections{
              ... on WpCsr{
                csrOptions{
                  title,
                  subtitle,
                  description,
                  url,
                  image{
                      mimeType,
                      mediaItemUrl,
                      mediaType,
                      altText,
                      title
                      gatsbyImage: localFile {
                        childImageSharp {
                          gatsbyImageData(
                            width: 650
                            placeholder: BLURRED
                            formats: [AUTO, WEBP]
                          )
                        }
                      }
                  }
                }
              }
            }
          },
          brands{
            active: brandsactive,
            title: brandstitle,
            description: brandsdescription,
            buttontext: brandsbuttontext
            brands{
              ... on WpBrand{
                brandOptions{
                  image{
                    mimeType,
                    mediaItemUrl,
                    mediaType,
                    altText,
                    title
                    gatsbySvg: localFile {
                      publicURL
                    }
                    gatsbyImage: localFile {
                      childImageSharp {
                        gatsbyImageData(
                          width: 1920
                          placeholder: BLURRED
                          formats: [AUTO, WEBP]
                          quality: 100
                        )
                      }
                    }
                  },
                  url
                }
              }
            }
          },
          statistics{
            title: statisticstitle
            active: statisticsactive,
            statistics{
              ... on WpStatistic{
                statisticOptions{
                  number,
                  numberdescription,
                  description,
                  icon{
                    mimeType,
                    mediaItemUrl,
                    mediaType,
                    altText,
                    title
                    gatsbySvg: localFile {
                      publicURL
                    }
                    gatsbyImage: localFile {
                      childImageSharp {
                        gatsbyImageData(
                          width: 60
                          placeholder: BLURRED
                          formats: [AUTO, WEBP]
                        )
                      }
                    }
                  },
                }
              }
            }
          },
          informations{
            title: informationstitle
            active: informationsactive,
            informations{
              ... on WpInformation{
                informationOptions{
                  title,
                  description,
                  image {
                    mediaItemUrl
                    mimeType,
                    mediaType,
                    altText,
                    title
                    gatsbyImage: localFile {
                      childImageSharp {
                        gatsbyImageData(
                          width: 650
                          placeholder: BLURRED
                          formats: [AUTO, WEBP]
                        )
                      }
                    }
                  }
                }
              }
            }
          }
        posts{
          active: postsactive,
          title: poststitle,
          subtitle: postssubtitle,
          buttontext: postsbuttontext
        },
        career{
          title: careertitle,
          active: careeractive,
          button: careerbutton{
            buttonlink: careerbuttonlink
            buttontext: careerbuttontext
          },
          description: careerdescription,
          image: careerimage {
            mediaItemUrl
            mimeType,
            mediaType,
            altText,
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 1920
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
        postsExtra{
          active: postsextraactive,
          title: postsextratitle,
          subtitle: postsextrasubtitle,
          url: postsextraurl,
          buttontext: postsextrabuttontext,
          textimage{
            mimeType,
            mediaItemUrl,
            mediaType,
            altText,
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 400
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  quality: 100
                )
              }
            }
          },
        }
        openGraphOptions{
          title: ogtitle
          description: ogdescription
          metatitle
          metadescription
          image: ogimage{
            mediaItemUrl
            mimeType
            mediaType
            altText
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 800
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      } 
    }
  }`)
  const pageData = allWpPage.nodes[0]
  return {
    title: pageData.title,
    informations: pageData.informations,
    intro: pageData.intro,
    mission: pageData.mission,
    csr: pageData.csr,
    brands: pageData.brands,
    statistics: pageData.statistics,
    posts: pageData.posts,
    postsExtra: pageData.postsExtra,
    career: pageData.career,
    openGraph: pageData.openGraphOptions
  }
}

export default useMainPageData